import React, { useMemo, useState } from "react";
import styles from '../styles/invitAward.module.scss'
import { useBaseConfig, useDepositConfigInfo, useGetInviteDepositVenuesV2, useGetPageActivityBetTaskTotal, useGetVipWeekInfo, useInviteDepositApply, useInvitePrizeConfig, useInvitePrizeInfo } from "../hooks/useInviteFriends";
import DialogApply from "./dialogApply";
import { useUserInfo } from "@/api/request";
import { useAuth } from "@/provides/authProvider";
import { useNavigate } from "react-router";
import { useModal } from "@/modals/modalContext";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import Toast from "@/wmCompoments/toast";
import Dialog from "@/wmCompoments/dialog";
import { useTranslation } from "react-i18next";


const InvitAward = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('inviteFriends')
  const { openModal } = useModal()
  // 获取个人配置信息
  const { data: userData, mutate: mutateUserInfo } = useUserInfo()
  // 是否登录
  const { token }=useAuth()
  // 邀请都有奖/存款大福利/现金天天赚－分享图/活动说明，规则查询
  const { mutate: mutateBaseConfig, baseConfigData } = useBaseConfig() || {}
  // 存款大优惠－邀请人，被邀请人申请状态接口
  const { mutate: matateDepositConfig, depositConfigData } = useDepositConfigInfo()
  // 存款申请
  const { trigger } = useInviteDepositApply()
  // 存款大优惠－场馆及奖励类型接口
  const { bonusType, data, isLoading: isLoadingDeposit, mutate } =useGetInviteDepositVenuesV2()
  const venueList = data?.data?.venueList?.filter(
    (item: any) => item.status === 1 && item.walletStatus === 0
  )
  const prizeTypeList = data?.data?.prizeTypeList?.map((item) => {
    const title = bonusType === 0
      ? `${t('invitAward.deposit')}${item.depositAmount}${t('invitAward.yuan')}${t('invitAward.give')}${item.bonusAmount}${t('invitAward.yuan')}，${t('invitAward.need')}${item.flowTimes}${t('invitAward.times')}${t('invitAward.turnover')}`
      : `${t('invitAward.deposit')}${item.depositAmount}${t('invitAward.yuan')}${t('invitAward.give')}${item.bonusRatio}%，${t('invitAward.highest')}${t('invitAward.give')}${item.bonusAmount}，${t('invitAward.need')}${item.flowTimes}${t('invitAward.times')}${t('invitAward.turnover')}`
    return { ...item, title }
  })
  // 现金天天赚-返利总计查询
  const { mutate: mutateGetPage } = useGetPageActivityBetTaskTotal()
  // 邀请都有奖－邀请人数及奖励查询
  const { mutate: mutateInvitePrizeInfo} = useInvitePrizeInfo()
  // 邀请都有奖－奖励配置信息查询
  const { mutate: mutateInvitePrizeConfig } = useInvitePrizeConfig()
  // 获取vip周活动
  const { trigger: refreshWeekInfo } = useGetVipWeekInfo();

  const [inviteRole, setInviteRole] = useState<number>(0)
  const [visible, setVisible] = useState(false)
  const [price, setPrice] = useState<string>('')
  const [activeBonusIndex, setActiveBonusIndex] = useState<number>(0)
  const [activeVenusIndex, setActiveVenusIndex] = useState<number>(0)

  const list = useMemo (()=>{
    return[
      {
        id: 1,
        imgSrc: baseConfigData?.list?.[1]?.inviteePrizePic,
        typeName: t('invitAward.inviteeReward'),
        typeDesc: t('invitAward.inviteeCondition'),
        applyStatus: depositConfigData?.inviteeApplyStatus,
      },
      {
        id: 0,
        imgSrc: baseConfigData?.list?.[1]?.inviterPrizePic,
        typeName: t('invitAward.inviterReward'),
        typeDesc: t('invitAward.inviterCondition'),
        applyStatus: depositConfigData?.inviterApplyStatus,
      }
    ]
  },[])

   /**
   * @param type 
   * type = 1 表示被邀请人
   * type =0 表示邀请人
   */
   const handleApply = (type: number, applyStatus: number) => {
    if (!userData?.isBindBankCard) {
      // 未绑卡，跳转绑卡页
      openModal('addCard')
      return
    }
    if (!token) {
      // 未登录，跳登录页
      openModal('login', { mode: 'invite' }) 
      return
    }
    if (applyStatus !== 2) return
    // 显示弹窗
    setInviteRole(type)
    setVisible(true)
  }

  /**
   * 确认
   */
  const onSubmitBtn = async () => {
    try {
      await trigger({
        venueId: venueList?.[activeVenusIndex]?.venueId ?? 0,
        prizeTypeId: prizeTypeList?.[activeBonusIndex]?.prizeTypeId ?? 0,
        applyAmount: bonusType == 1 ? Number(price) : Number(prizeTypeList?.[activeBonusIndex]?.depositAmount),
        inviteRole: inviteRole,
        grade: userData?.grade ?? 0,
      })
      await Promise.all([matateDepositConfig,mutateGetPage,mutateInvitePrizeInfo,mutateBaseConfig,mutateInvitePrizeConfig,refreshWeekInfo])
      Toast.show(t('invitAward.applySuccess'))
    } catch (error: any) {
      ErrorMessageDialog(error?.message)
    }
  }

  return (
    <>
      <div className={styles.invitAward}>
        {list.map((v,index)=>{
          return <div key={index} className={styles.item}>
            <img src={v.imgSrc} alt="" />
            <div className={styles.content}>
              <div className={styles.type}>
                <div>{v.typeName}</div>
                <div>{v.typeDesc}</div>
              </div>
              <button 
                disabled={v.applyStatus !== 2}
                onClick={()=>handleApply(v.id, v.applyStatus)}
              >
                {t('invitAward.applyNow')}
              </button>
            </div>
          </div>
        })}
      </div>

      <Dialog
        visible={visible}
        onClose={() => setVisible(false)}
        actions={[
            {
              key: 'cancel',
              text: t('invitAward.cancel'),
              onClick: () => {
                setVisible(false)
              }
            },
            {
              key: 'confirm',
              text: t('invitAward.confirm'),
              onClick: onSubmitBtn
            }
        ]}
        content={
          <div className={styles.dialog_content}>
            <DialogApply
              bonusType={bonusType}
              venueList={venueList}
              prizeTypeList={prizeTypeList}
              isLoading={isLoadingDeposit}
              price={price}
              activeBonus={activeBonusIndex}
              activeVenus={activeVenusIndex}
              onSelectBonusRetry={(i: number) => setActiveBonusIndex(i)}
              onSelectVenuRetry={(i: number) => setActiveVenusIndex(i)}
              onChangePriceRetry={(val: string) => setPrice(val)}
            />
          </div>
        }
      />
    </>
  )
}

export default InvitAward

